import { gql } from '@apollo/client'

export default gql`
  mutation mortgageWidgetFetchProducts($input: MortgageWidgetSubmissionInput, $productTypes: [MortgageWidgetProductTypeEnum!]) {
    mortgageWidgetFetchProducts(input: $input) {
      uuid
      ficoType
      zipCode
      vertical
      estimatedValue
      status
      downPayment
      homeValue
      loanAmount
      occupancyType
      propertyType
      products (productTypes: $productTypes){
        uuid
        externalProductId
        lender {
          name
          nmls
          slug
        }
        productType
        monthlyPayment
        loanTerm
        amortizationType
        rate
        apr
        fees
      }
    }
  }
`
